import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Monitor, Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "@/i18n/LanguageContext";

const OPTIONS = [
  { value: "light", labelKey: "common.misc.themeLight", icon: Sun },
  { value: "dark", labelKey: "common.misc.themeDark", icon: Moon },
  { value: "system", labelKey: "common.misc.themeSystem", icon: Monitor },
];

export default function ThemeToggle() {
  const t = useTranslation();
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // next-themes only knows the resolved theme after mount; avoid a hydration flash.
  useEffect(() => setMounted(true), []);
  const active = mounted ? theme : undefined;

  return (
    <div className="px-2">
      <div className="mono-eyebrow mb-2 !text-[9px]">{t("common.misc.theme")}</div>
      <div
        role="radiogroup"
        aria-label={t("common.misc.theme")}
        className="grid grid-cols-3 gap-1 rounded-lg border border-border bg-background p-1"
      >
        {OPTIONS.map(({ value, labelKey, icon: Icon }) => (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={active === value}
            title={t(labelKey)}
            onClick={() => setTheme(value)}
            data-testid={`theme-option-${value}`}
            className={cn(
              "flex h-7 items-center justify-center rounded-md text-muted-foreground transition-colors",
              "hover:text-foreground",
              active === value && "bg-muted text-foreground",
            )}
          >
            <Icon className="h-3.5 w-3.5" strokeWidth={1.5} />
            <span className="sr-only">{t(labelKey)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
